import { render, staticRenderFns } from "./ReportsExceedingGraduates.vue?vue&type=template&id=10d6854f&"
import script from "./ReportsExceedingGraduates.vue?vue&type=script&lang=js&"
export * from "./ReportsExceedingGraduates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports